module.exports = __webpack_public_path__ + "static/media/Inter-Regular.6327df22.woff";